import SignalRManager from '@/services/signalrManager'

export default {
    install(Vue, options) {
        if (!options || !options.url) {
            throw new Error('SignalR plugin: url obbligatoria')
        }

        const manager = SignalRManager

        Vue.prototype.$signalr = {
            start(config) {
                return manager.connect({
                    url: options.url,
                    ...config
                })
            },

            call(hub, method, ...args) {
                return manager.call(hub, method, ...args)
            },

            stop() {
                manager.stop()
            }
        }
    }
}
